const missionControl = {
  header: {
    title: 'Missionskontrolle',
    createScenario: 'EIN NEUES SZENARIO ERSTELLEN',
  },

  cards: {
    titles: {
      co2Savings: 'CO2-Einsparungen',
      onTimePerfformance: 'Pünktliche Leistung',
      vehicleEfficiency: 'Fahrzeugeffizienz',
      passengerSatisfaction: 'Fahrgastzufriedenheit',
      costPerMile: 'Kosten pro Meile',
    },
  },

  layers: {
    title: 'Kartenebene',

    titles: {
      visibility: 'Sichtweite',
      layerDate: 'Ebenendaten',
      visualRepresenatation: 'Visuelle Darstellung',
    },

    filters: {
      status: {
        title: 'Status',
        placeholder: 'Status',
        options: {
          new: 'Neu',
          on_hold: 'In der Warteschleife',
          routing: 'Routenplanung',
          routed: 'Geroutet',
          canceled: 'Storniert',
          picked: 'Ausgewählt',
          dropped: 'Abgesetzt',
          noshow: 'No-Show',
          queued: 'In der Warteschlange',
        },
      },

      zones: {
        title: 'Zone',
      },

      powerType: {
        title: 'Ladeleistung',
        placeholder: 'Ladeleistung',
        options: {
          fast: 'Schnell',
          slow: 'Langsam',
          turbo: 'Turbo',
        },
      },

      connectorType: {
        title: 'Steckertyp',
        placeholder: 'Steckertyp',
        options: {
          EC_Type_1: 'IEC Type 1',
          IEC_Type_2_J1772: 'IEC Type 2 (J1772)',
          IEC_Type_2: 'IEC Type 2',
          IEC_Type_3: 'IEC Type 3',
          CHAOJI: 'CHAOJI',
          NEMA: 'NEMA',
          TESLA: 'TESLA',
          CHADEMO: 'CHADEMO',
          GBT: 'AGB',
        },
      },
    },

    content: {
      traffic: {
        title: 'Verkehr',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte zeigen',
        mildlyhigher: 'Leicht höher',
        trafficJam: 'Stau',
      },

      evsChargingPoints: {
        title: 'Ladestationen für Elektrofahrzeuge',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte zeigen',
        chargingPointOptions: {
          fast: 'Schnellladestation',
          slow: 'Langsamer Ladepunkt',
        },
      },

      heatMap: {
        title: 'Wärmekarte',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte zeigen',
        scaleOfDemand: 'Umfang der Nachfrage',
      },

      dots: {
        title: 'Punkte',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte sehen',
        numberOfDemands: 'Anzahl der Nachfragen',
      },

      tripsLiveStream: {
        title: 'Live-Stream von Fahrten',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte zeigen',
        tripProgress: 'Fahrtverlauf',
        pickUp: 'Abholen',
        dropOff: 'Absetzen',
      },
    },
  },

  kpis: {
    title: 'KPIs',

    titles: {
      driversAndVehicles: 'Fahrer & Fahrzeuge',
      routes: 'Routen',
    },
  },
};

export default missionControl;
